import { makeStyles } from '@material-ui/core/styles';
import { condensedStyles } from 'core/components/theme/condensed-layout';

const useStyles = makeStyles((theme) => ({
  container: {
    width: 720,
    ...condensedStyles(theme, { width: '100%', maxWidth: 720 }),
    margin: '0 auto',
    marginTop: theme.spacing(4)
  }
}));

export default useStyles;
